import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {Editor, toHTML, Toolbar} from 'ngx-editor';

@Component({
  selector: 'app-modal-create-note',
  templateUrl: './modal-create-note.component.html',
  styleUrls: ['./modal-create-note.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCreateNoteComponent implements OnInit, OnDestroy {
  // tslint:disable:no-redundant-jsdoc
  @Input() isVisibleModal: boolean;
  @Input() messageCreateNote: string;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '250px',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    sanitize: true,
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontSize', 'customClasses', 'unlink', 'insertImage', 'insertVideo', 'removeFormat', 'toggleEditorMode']
    ]
  };
  note;
  shareNote: boolean;
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify']
  ];
  constructor() { }

  /**
   * Inicializa las propiedades necesarias
   */
  ngOnInit(): void {
    this.editor = new Editor();
    this.note = {
      type: 'doc',
      content: []
    };
  }

  /**
   * resetea el contenedor del comentario.
   */
  resetModal(): void {
    this.note = {
      type: 'doc',
      content: []
    };
    this.shareNote = false;
  }

  /**
   * Se emite al componente padre que se cerró el modal.
   * @param value
   */
  onEmitCloseModal(value: boolean): void {
    if (!value) {
      this.note = {
        type: 'doc',
        content: []
      };
      this.shareNote = false;
    }
    this.closeModal.emit({
      action: value,
      note: toHTML(this.note),
      isShared: this.shareNote
    });
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
